export default __webpack_public_path__ + "static/media/fifth.dc2a00d9.m4a";